<template>
  <AsyncPage
    :loader="useRepairsLoader"
    :page-component="Repairs"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useRepairsLoader } from "./Repairs.loader.ts";
import { repairs as strings } from "./Repairs.strings.ts";
import { AsyncPage } from "@saflib/vue/components";
import { useAsyncPageDocumentTitle } from "@saflib/vue";

useAsyncPageDocumentTitle(strings.documentTitle);

const Repairs = defineAsyncComponent(
  () => import("./Repairs.vue"),
);
</script>
